export function AIBookingDemo() {
  return (
    <div className="w-full bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-6 sm:p-8 lg:p-12">
      {/* Main container with improved responsive grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12 items-center">
        
        {/* Phone Mockup - Left */}
        <div className="flex justify-center md:justify-start lg:justify-end order-1 md:order-1">
          <div className="relative w-full max-w-[280px] sm:max-w-[380px]">
            <img 
              src="/phone-mockup.svg" 
              alt="AI Golf Assistant Chat Interface"
              className="w-full h-auto drop-shadow-xl"
            />
          </div>
        </div>
        
        {/* Voice Section - Center */}
        <div className="flex flex-col items-center text-center space-y-1 sm:space-y-6 order-3 md:order-2 md:col-span-2 lg:col-span-1">
          <h3 className="text-xl sm:text-2xl font-semibold text-emerald-900">Or just say:</h3>
          
          {/* Voice Wave Animation */}
          <div className="w-24 sm:w-36 h-36">
            <img 
              src="/voice-wave.svg" 
              alt="Voice command visualization"
              className="w-full h-full"
            />
          </div>
          
          {/* Speech Bubble */}
          <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg max-w-xs sm:max-w-sm">
            <p className="text-gray-700 italic text-base sm:text-lg">
              "Book me a tee time for Saturday morning with three friends"
            </p>
          </div>
          
          {/* Tagline - hidden on small screens, shown on medium+ */}
          <p className="text-xs sm:text-sm text-gray-600 max-w-xs sm:max-w-md px-4 sm:px-0">
            Seamless booking through chat, voice, or phone - your golfers choose how they interact
          </p>
        </div>
        
        {/* Features List - Right */}
        <div className="space-y-3 sm:space-y-4 order-2 md:order-3 md:col-span-1">
          <h3 className="text-lg sm:text-xl font-semibold text-emerald-900 mb-3 sm:mb-4">AI Features:</h3>
          <ul className="space-y-2 sm:space-y-3">
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mt-1.5 sm:mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm sm:text-base text-gray-700">24/7 Availability</span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mt-1.5 sm:mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm sm:text-base text-gray-700">Natural Language Understanding</span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mt-1.5 sm:mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm sm:text-base text-gray-700">Instant Confirmation</span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mt-1.5 sm:mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm sm:text-base text-gray-700">Integrations with Calendly, Cal.com, Salesforce and more!*</span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mt-1.5 sm:mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm sm:text-base text-gray-700">Smart Suggestions</span>
            </li>
          </ul>
          <p className="text-xs text-gray-500 mt-4 italic">
            * Integration availability varies by platform. Custom API integrations available upon request.
          </p>
        </div>
      </div>
    </div>
  )
}